export { MedicalDocumentViewModal } from './MedicalDocumentViewModal';
